// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-cont-NotifiTech{
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
}
.body-cont-NotifiTech .top-content,.body-cont-NotifiTech .bottom-content{
  position: relative;
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.body-cont-NotifiTech .center-content{
  position: relative;
  width: 100%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
 
}

.body-cont-NotifiTech .center-content .table-tech{
  position: relative;
  width: 90%;
  height: 90%;
  display: block;
 border: solid 1px gray;
 overflow: auto;
}
.table-tech .row-element-tech{
  position: relative;
  width: 100%;
  height: 13%;
  display: flex;

}
.row-element-tech .field-element{
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: small;
  color: #003757;
}
.row-element-tech:nth-child(odd){
  background-color: #f8f9fa;
}
.row-element-tech:nth-child(even){
  background-color: #eeeeee;
}

.top-content .field-content{
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #003757;
}

.top-content .field-content .group{
  width: 80%;
}

.top-content .field-content .icon{
  fill:  #003757 !important;
}

.top-content .field-content .group .inputSearch::placeholder {
  color: rgb(59, 59, 59);
}

.bottom-content .cont-buton{
position: relative;
width: 50%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/admin-components/styles/ModalSelectTech.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;CACf,sBAAsB;CACtB,cAAc;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;;AAEf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;AACA,kBAAkB;AAClB,UAAU;AACV,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB","sourcesContent":[".body-cont-NotifiTech{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n}\r\n.body-cont-NotifiTech .top-content,.body-cont-NotifiTech .bottom-content{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 15%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.body-cont-NotifiTech .center-content{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 70%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n \r\n}\r\n\r\n.body-cont-NotifiTech .center-content .table-tech{\r\n  position: relative;\r\n  width: 90%;\r\n  height: 90%;\r\n  display: block;\r\n border: solid 1px gray;\r\n overflow: auto;\r\n}\r\n.table-tech .row-element-tech{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 13%;\r\n  display: flex;\r\n\r\n}\r\n.row-element-tech .field-element{\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: small;\r\n  color: #003757;\r\n}\r\n.row-element-tech:nth-child(odd){\r\n  background-color: #f8f9fa;\r\n}\r\n.row-element-tech:nth-child(even){\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.top-content .field-content{\r\n  position: relative;\r\n  width: 50%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #003757;\r\n}\r\n\r\n.top-content .field-content .group{\r\n  width: 80%;\r\n}\r\n\r\n.top-content .field-content .icon{\r\n  fill:  #003757 !important;\r\n}\r\n\r\n.top-content .field-content .group .inputSearch::placeholder {\r\n  color: rgb(59, 59, 59);\r\n}\r\n\r\n.bottom-content .cont-buton{\r\nposition: relative;\r\nwidth: 50%;\r\nheight: 100%;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
